module.exports = __webpack_public_path__ + "img/logo13.ac32498a.svg";